import { getMediasVariant } from "../../../Header/components/TopBar/HeaderCircle";
import { FetchFCCRecommendedProducts } from "./FCCRecommendationsSection";
import { PurchasePlaceProvider } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

export interface FCCGapProdRecomSectionProps {
  className?: string;
}

export const FCCGapProductRecommendation = (props: FCCGapProdRecomSectionProps) => {
  const role = getMediasVariant();
  const isBusiness = role === "business";

  if (!isBusiness) {
    return null;
  }
  if (!window.SCHA.toggles.fccGapProdsRecommendation) {
    return null;
  }
  return <FetchFCCRecommendedProducts {...props} />;
};

export function createSchaefflerFccRecommendationComponent() {
  return (
    <PurchasePlaceProvider value={"HOME"}>
      <FCCGapProductRecommendation />
    </PurchasePlaceProvider>
  );
}
